import { render, staticRenderFns } from "../../assets/templates/StartPlataformas/VinculosPage.html?vue&type=template&id=431a2c60&scoped=true&"
import script from "../../assets/scripts/StartPlataformas/VinculosPage.js?vue&type=script&lang=js&"
export * from "../../assets/scripts/StartPlataformas/VinculosPage.js?vue&type=script&lang=js&"
import style0 from "../../assets/scss/vinculosPage.scss?vue&type=style&index=0&id=431a2c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431a2c60",
  null
  
)

export default component.exports